export const SOCIAL_LINKS = {
    YOUTUBE: 'https://www.youtube.com/@RazulArtworks',
    ARTSTATION: 'https://www.artstation.com/razulartworks',
    // ... other social links
};

export const ROUTES = {
    HOME: '/',
    ABOUT: '/about',
    BLOG: '/blog',
    CONTACT: '/contact-us'
};

export const STRAPI_URL = import.meta.env.VITE_STRAPI_URL || 'http://localhost:1337';
export const STRAPI_API = {
    ARTICLES: `${STRAPI_URL}/api/articles`,
    CATEGORIES: `${STRAPI_URL}/api/categories`,
    MEDIA: `${STRAPI_URL}/api/upload`
}; 